import moment from 'moment';

const resolveIntlLocale = (locale?: string | null): string => (locale === 'en' ? 'en-US' : 'de-DE');
const resolveMomentLocale = (locale?: string | null): string => (locale === 'en' ? 'en' : 'de');

export const formatInvoiceCurrency = (value: number, locale?: string | null, currency = 'EUR'): string =>
    new Intl.NumberFormat(resolveIntlLocale(locale), { style: 'currency', currency }).format(value);

export const formatInvoiceNumber = (value: number, locale?: string | null): string =>
    new Intl.NumberFormat(resolveIntlLocale(locale)).format(value);

export const formatInvoicePercent = (value: number, locale?: string | null): string =>
    `${new Intl.NumberFormat(resolveIntlLocale(locale), { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(value)} %`;

export const formatInvoiceDate = (date?: string | Date | null, locale?: string | null): string =>
    date ? new Date(date).toLocaleDateString(resolveIntlLocale(locale)) : '—';

export const formatInvoiceMoment = (date?: string | Date | null, locale?: string | null, format = 'L'): string =>
    date ? moment(date).locale(resolveMomentLocale(locale)).format(format) : '-';

/** Year options for the report filters: current year and the five preceding ones. */
export const buildYearOptions = () =>
    Array.from({ length: 6 }, (_, i) => {
        const year = String(new Date().getFullYear() - i);
        return { label: year, value: year };
    });

/**
 * Month options for the report filters, localised. The empty value means "whole year",
 * which is what the endpoints fall back to when no month is sent.
 */
export const buildMonthOptions = (locale: string | null | undefined, allLabel: string) => {
    const formatter = new Intl.DateTimeFormat(resolveIntlLocale(locale), { month: 'long' });

    return [
        { label: allLabel, value: '' },
        ...Array.from({ length: 12 }, (_, i) => ({
            label: formatter.format(new Date(2020, i, 1)),
            value: String(i + 1)
        }))
    ];
};
